import {Component, ViewChild} from '@angular/core';
import {RouterLink} from "@angular/router";
import {MatCardModule} from "@angular/material/card";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {ColorPickerModule} from "ngx-color-picker";
import {MatRadioModule} from "@angular/material/radio";
import {MatDividerModule} from "@angular/material/divider";
import {MatSort} from "@angular/material/sort";
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';

import {LockerLight} from '../../apis/models/lockerLight';
import {LockerHelper} from '../../helpers/locker.helper';
import {LockersService} from '../../apis/services/lockers.service';
import {CustomizerSettingsService} from '../../helpers/customizer-settings.service';
import {CommonHelpers} from '../../helpers/common.helper';

export enum SortByEnum {
  LOCKER_TYPE = 'Tipologia locker',
  LOCKER_STATUS = 'Stato'
}

@Component({
  selector: 'lockers',
  standalone: true,
  imports: [RouterLink, MatCardModule, MatMenuModule, MatButtonModule, MatTableModule, MatPaginatorModule, FormsModule, MatFormFieldModule,  MatInputModule, MatIconModule, ReactiveFormsModule, ColorPickerModule, MatRadioModule, MatDividerModule],
  templateUrl: './lockers.component.html',
  styleUrl: './lockers.component.scss'
})
export class LockersComponent {

  isToggled: boolean = false;

  displayedColumns: string[] = ['IDLockerRacc', 'tenantType', 'address', 'city', 'province', 'cap', 'status', 'actions'];
  columns: string[] = [];
  dataSource = new MatTableDataSource<LockerLight>([]);
  sortby: string = SortByEnum.LOCKER_TYPE

  protected readonly sortEnumList = Object.values(SortByEnum);

  IDLocker: number | null;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(
    public themeService: CustomizerSettingsService,
    private lockerHelper: LockerHelper,
    private commonHelpers: CommonHelpers,
    private lockerService: LockersService,
    public dialog: MatDialog
  ) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
  });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // RTL Mode
  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }

  ngOnInit(): void {
    this.lockerHelper.lockerSubject.subscribe(dataSource => {
        this.dataSource.data = dataSource;
    });
    this.loadLockers();
  }

  loadLockers(){
    this.lockerService.getLockers().subscribe({
      next: (res) => {
        this.columns = res.rows[0];
        this.dataSource.data = res.rows.slice(1).map((row: any[]) => {
            const rowData: any = {};
            this.columns.forEach((header, index) => {
                rowData[header] = row[index];
            });
            return rowData;
        });
      }
    })
  }

  deleteLocker(IDLocker: number){
    this.lockerService.deleteLockerById(IDLocker).subscribe({
      next: () => {
        this.dataSource.data = this.dataSource.data.filter(locker => locker.IDLockerRacc !== IDLocker)
      },
      error: (error) => {
        this.commonHelpers.openSnackBar("Si è verificato un errore durante l'eliminazione del Locker", "x", 5);
        console.error('Error occurred while deleting locker:', error);
    }
    })
  }

  sortBy(type: SortByEnum){
    this.sortby = type
    switch (type) {
      case SortByEnum.LOCKER_TYPE:
        this.dataSource.data.sort((a, b) => a.tenantType!.localeCompare(b.tenantType!));
        this.dataSource._updateChangeSubscription();
        break;
      case SortByEnum.LOCKER_STATUS:
        this.dataSource.data.sort((a, b) => a.lockerStatus!.localeCompare(b.lockerStatus!));
        this.dataSource._updateChangeSubscription();
        break;
    }
  }

  openDeleteDialog(IDLocker: number): void {
    const dialogRef = this.dialog.open(LockerDeleteDialog, {});
    dialogRef.afterClosed().subscribe(result => {
        if(result){
            this.deleteLocker(IDLocker)
        }
    });
  }
}



@Component({
    selector: 'delete-locker-dialog',
    templateUrl: 'delete-locker-dialog.component.html',
    imports: [
        MatFormFieldModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
    ],
    standalone: true
})
export class LockerDeleteDialog {
  constructor(public dialogRef: MatDialogRef<LockerDeleteDialog>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
